import { Component, OnInit } from "@angular/core";
import { HrserviceService } from "../../hr-manager/service/hrservice.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Subject } from "rxjs";
import { EmponboardingService } from "../../employee-onboarding/services/emponboarding.service";
import { LoginService } from "src/app/core/login/login.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { MatDialog } from "@angular/material/dialog";
import { ExcelService } from "src/app/core/services/excel.service";
import { BusinessFilterDialogComponent } from "./business-filter-dialog.component";
import { BusinessDialogComponent } from "../business-dialog/business-dialog.component";
import { AddItemDialogComponent } from '../shared/add-item-dialog/add-item-dialog.component';
import { AddDialogConfigs } from '../shared/add-item-dialog/add-dialog-configs';

@Component({
    selector: "app-business-list",
    templateUrl: "./business-list.component.html",
    styleUrls: ["./business-list.component.scss", "../shared/hr-table-styles.scss"],
    providers: [ExcelService]
})

export class BusinessListComponent implements OnInit {
    headingBusiness: string = "Business Units";
    businesslist: any;
    headList: any[];
    searchQuery: string = '';
    private searchSubject = new Subject<string>();
    
    // Filter state object
    currentFilters = {
        name: '',
        head_id: ''
    };
    page = 1;
    pageSize = 10;
    totalItems = 0;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private hrservice: HrserviceService,
        private EmpOnboardingService: EmponboardingService,
        private loginService: LoginService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
        private excelService: ExcelService
    ) {
        // Setup search with debounce
        this.searchSubject
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((query) => {
                // Only update name filter, preserve other filters
                this.currentFilters.name = query;
                this.page = 1;
                this.getBusinesses();
            });
    }

    ngOnInit(): void {
        // Load business heads first
        this.hrservice.getBusinessHeads().subscribe((res: any) => {
            this.headList = res.data || [];
            console.log('Business heads loaded:', this.headList);
        });
        
        // Load businesses with filters
        this.getBusinesses();
    }

    // Handle search input
    onSearchInput(query: string): void {
        this.searchQuery = query;
        this.searchSubject.next(query);
    }

    // Open filter dialog
    openFilterDialog(): void {
        const dialogRef = this.dialog.open(BusinessFilterDialogComponent, {
            width: '800px',
            maxWidth: '90vw',
            data: {
                filters: { ...this.currentFilters }, // Retain current filter state
                headList: this.headList || []
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.currentFilters = { ...result };
                this.page = 1;
                this.getBusinesses();
            }
        });
    }

    // Get businesses with filters and pagination
    getBusinesses(): void {
        const params = {
            page: this.page,
            name: this.currentFilters.name || '',
            head_id: this.currentFilters.head_id || ''
        };
        console.log('Business API params:', params);
        this.hrservice.getBusinessList(params).subscribe((res: any) => {
            this.businesslist = res.data.businesses || res.data;
            this.totalItems = res.data.total_count || 0;
        });
    }

    // Handle page changes
    handlePageChange(newPage: number): void {
        this.page = newPage;
        this.getBusinesses();
    }

    // Add business dialog
    addBusiness() {
        const dialogRef = this.dialog.open(BusinessDialogComponent, {
            width: '700px',
            data: { 
                type: 'create'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('New business data:', result);
                // Call your API to add the business
                this.saveBusiness(result);
            }
        });
    }

    // Save new business
    saveBusiness(businessData: any): void {
        console.log('Saving business:', businessData);
        // Implement API call here
    }

    // Edit business
    editBusiness(business: any) {
        this.loaderService.setLoading(true);
        // Logic to find head and other processing
        
        let dialogRef = this.dialog.open(BusinessDialogComponent, {
            data: {
                type: 'edit',
                data: business
            },
        });
    }

    // Export businesses with current filters
    exportBusinesses(): void {
        const params = {
            name: this.currentFilters.name || '',
            head_id: this.currentFilters.head_id || ''
        };
        this.hrservice.exportBusinessList(params).subscribe((res: any) => {
            // Handle file download
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `businesses_${this.getExportDate()}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    private getExportDate(): string {
        return new Date().toISOString().slice(0, 10);
    }
}